import BaseService from '../BaseService'
import axios from "axios";

class SettingService extends BaseService {
    constructor() {
        super('/settings');
    }

    updateSetting({payload}) {
        return axios.put(`${this.resource}`, payload)
    }

    getSetting() {
        return axios.get(`${this.resource}`)
    }
}

export default new SettingService()
